import { Button, Form, Modal } from 'antd';
import { useDispatch, useSelector } from 'react-redux';
import { apiResponseModalSliceDispatch, reducerDispatch, selectFileSliceDispatch, uploadFileSliceDispatch } from "../../Constants/ReduxConstants";

export default function ApiResponseModal() {
    const uploadFileApiResponse = useSelector((state: any) => state.uploadFile.apiResponse);
    const selectFileApiResponse = useSelector((state: any) => state.selectFile.apiResponse);
    const apiSuccess = useSelector((state: any) => state.selectFile.apiSuccess);

    const open = useSelector((state: any) => state.apiResponseModal.open);

    const dispatch = useDispatch()
    const onSubmit = () => {
        //If api errors recet state.
        if (!apiSuccess)
            dispatch({ type: reducerDispatch.resetState });

        dispatch({ type: apiResponseModalSliceDispatch.setOpen, payload: false });
        dispatch({ type: uploadFileSliceDispatch.setApiResponse, payload: "" });
        dispatch({ type: selectFileSliceDispatch.setApiResponse, payload: "" });

        dispatch({ type: selectFileSliceDispatch.setIsDataModel, payload: false });
        dispatch({ type: selectFileSliceDispatch.setIsTemplate, payload: false });
    }

    return (
        <Modal
            open={open && (uploadFileApiResponse != "" || selectFileApiResponse != "")}
            footer={null}
            closable={false}
            destroyOnHidden={true}
        >
            <Form
                onFinish={onSubmit}
                preserve={false}
            >
                {uploadFileApiResponse != "" ? (
                    <p>{uploadFileApiResponse}</p>
                ) : (
                    <p>{selectFileApiResponse}</p>
                )}
                <div style={{ display: 'flex', justifyContent: 'end', paddingTop: '1em' }}>
                    <Form.Item>
                        <Button htmlType="submit">
                            Submit
                        </Button>
                    </Form.Item>
                </div>
            </Form>
        </Modal >
    );
}